(function() {
  'use strict';

  var PERSONALISE_SELECTORS = [
    '#openPersonalizationModal',
    '.btn-personalize-product',
    '.product-form__buy-buttons .pplr-btn',
    '.product-form__buy-buttons button.pplr-c-button',
    '.product-personalizer .pplr-btn',
    '.product-personalizer button.pplr-c-button',
    '.product-personalizer button.btn',
    '.troopod_atc'
  ];

  function formatVariantMoney(cents) {
    if (typeof formatMoney === 'function' && window.themeVariables && window.themeVariables.settings) {
      var currencyFormat = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;
      return formatMoney(cents, currencyFormat);
    }

    return (cents / 100).toFixed(2);
  }

  function getSoldOutLabel() {
    if (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.productFormSoldOut) {
      return window.themeVariables.strings.productFormSoldOut;
    }

    return 'Sold out';
  }

  function findPersonalisationTrigger() {
    var i;
    var el;

    for (i = 0; i < PERSONALISE_SELECTORS.length; i++) {
      el = document.querySelector(PERSONALISE_SELECTORS[i]);
      if (el) return el;
    }

    var buyButtons = document.querySelector('.product-form__buy-buttons');
    if (buyButtons) {
      var buttons = buyButtons.querySelectorAll('button, a, [role="button"]');
      for (i = 0; i < buttons.length; i++) {
        var label = (buttons[i].textContent || '').trim();
        if (/customise|customize|personalise|personalize/i.test(label)) {
          return buttons[i];
        }
      }
    }

    return null;
  }

  function openPersonalisationPopup(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var trigger = findPersonalisationTrigger();
    if (trigger) {
      trigger.click();
      return;
    }

    if (window.PersonalizationModal && typeof window.PersonalizationModal.open === 'function') {
      window.PersonalizationModal.open();
    }
  }

  function updateStickyVariantDetails(variant) {
    if (!variant) return;

    var comparePriceEl = document.querySelector('[data-sticky-compare-price]');
    var discountEl = document.querySelector('[data-sticky-discount]');

    if (comparePriceEl && discountEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatVariantMoney(variant.compare_at_price);
        comparePriceEl.hidden = false;

        var discountPct = Math.round(
          ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
        );
        discountEl.textContent = discountPct + '% Off';
        discountEl.hidden = false;
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.hidden = true;
        discountEl.textContent = '';
        discountEl.hidden = true;
      }
    }

    var stickyButtons = document.querySelectorAll('.rabitat-sticky-cart [data-product-add-to-cart-button]');
    stickyButtons.forEach(function(button) {
      button.disabled = !variant.available;
      button.classList.toggle('button--ternary', !variant.available);

      if (variant.available) {
        var defaultLabel = button.getAttribute('data-button-content');
        if (defaultLabel) button.textContent = defaultLabel;
      } else {
        button.textContent = getSoldOutLabel();
      }
    });
  }

  function initStickyPersonalise() {
    document.addEventListener('click', function(event) {
      if (
        event.target.closest('.rabitat-sticky-cart__personalise-banner') ||
        event.target.closest('.product-sticky-form__desktop-personalise')
      ) {
        openPersonalisationPopup(event);
      }
    });
  }

  function setupStickyVisibility() {
    var sticky = document.querySelector('product-sticky-form.rabitat-sticky-cart');
    if (!sticky) return;

    if (sticky.intersectionObserver) {
      sticky.intersectionObserver.disconnect();
    }

    if (sticky._rabitatVisibilityObserver) {
      sticky._rabitatVisibilityObserver.disconnect();
    }

    var atcTarget = document.getElementById('MainPaymentContainer') || document.getElementById('AddToCart');
    var footer = document.querySelector('.shopify-section--footer');

    if (!atcTarget) return;

    var atcVisible = false;
    var footerVisible = false;

    function updateVisibility() {
      sticky.hidden = atcVisible || footerVisible;
    }

    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (entry.target === atcTarget) {
            atcVisible = entry.isIntersecting;
          }
          if (footer && entry.target === footer) {
            footerVisible = entry.isIntersecting;
          }
        });
        updateVisibility();
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -10px 0px'
      }
    );

    observer.observe(atcTarget);
    if (footer) observer.observe(footer);

    sticky._rabitatVisibilityObserver = observer;

    requestAnimationFrame(updateVisibility);
  }

  function init() {
    initStickyPersonalise();

    function bootVisibility() {
      setupStickyVisibility();
      setTimeout(setupStickyVisibility, 50);
    }

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('product-sticky-form').then(bootVisibility);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootVisibility);
    } else {
      bootVisibility();
    }
  }

  document.addEventListener('variant:changed', function(event) {
    updateStickyVariantDetails(event.detail && event.detail.variant);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
